import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'NewsArticleView.heading',
    defaultMessage: 'Aktualności'
  },
  return: {
    id: 'NewsArticleView.return',
    defaultMessage: 'POWRÓT'
  },
  similarNews: {
    id: 'NewsArticleView.similarNews',
    defaultMessage: 'PODOBNE AKTUALNOŚCI'
  }
});



// WEBPACK FOOTER //
// ./src/views/News/NewsArticleView.intl.js